import React, { useEffect, useState } from "react";
import bars from "../icons/bars.svg";
import close from "../icons/close.svg";
// import linkedinIcon from "../icons/linkedin.svg";
import instagram from "../icons/instagram.svg";
import whats from "../icons/whats.svg";
import drgG from "../images/drgG.png";
import google from "../icons/google.svg";
import tiktok from "../icons/tiktok.svg";
import doctoralia from "../images/doctoralia.png";
// import { HashLink } from "react-router-hash-link";

const Headerbar = ({ lang, toggle }) => {
  const [show, setShow] = React.useState(false);
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    function updateSize() {
      if (window.innerWidth > 800) {
        setMobile(false);
        setShow(true);
      } else {
        setMobile(true);
        setShow(false);
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const handleOpener = () => {
    mobile && setShow(!show);
  };

  return (
    <>
      <div className={`headerbar ${!show && `hidden`}`}>
        <div className="name">
          <img
            style={{ height: "40px", marginTop: "8px" }}
            src={drgG}
            alt="Dr. Gilberto"
          />
        </div>
        <div className={mobile ? `topics-mobile` : `topics`}>
          <div>
            <a href="#about">Sobre mim</a>
            {mobile && (
              <>
                <br />
                <br />
              </>
            )}
            <a href="#contato">Agendamento e Contato</a>
          </div>
          {mobile && (
            <div className="mobile-social">
              <a
                href="https://www.doctoralia.com.br/gilberto-cascaes-guedes-neto/infectologista-especialista-em-clinica-medica/foz-do-iguacu"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="doctoralia"
                  src={doctoralia}
                  alt={"doctoraliaIcon"}
                />
              </a>
              <a
                href="https://wa.me/+554195722844?text=Olá%2C%20gostaria%20de%20agendar%20uma%20consulta."
                target="_blank"
                rel="noreferrer"
              >
                <img
                  style={{ width: "82px" }}
                  className="whats reverse"
                  src={whats}
                  alt={"whatsIcon"}
                />
              </a>
              <a
                href="https://www.instagram.com/dr.gilbertoinfecto/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="instagram reverse"
                  src={instagram}
                  alt={"instagramIcon"}
                />
              </a>

              <a
                href="https://www.google.com/maps/place/Dr+Gilberto+Cascaes+Infectologista/@-25.4520663,-49.3757462,65977m/data=!3m1!1e3!4m18!1m9!3m8!1s0x40abf5a9a3778f89:0x8398cf976d4abc44!2sDr+Gilberto+Cascaes+Infectologista!8m2!3d-25.4951166!4d-49.2897982!9m1!1b1!16s%2Fg%2F11x7wjbwt0!3m7!1s0x40abf5a9a3778f89:0x8398cf976d4abc44!8m2!3d-25.4951166!4d-49.2897982!9m1!1b1!16s%2Fg%2F11x7wjbwt0?entry=ttu&g_ep=EgoyMDI1MDkwNy4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  style={{ width: "74px" }}
                  className="google reverse"
                  src={google}
                  alt={"googleIcon"}
                />
              </a>
              <a
                href="https://www.tiktok.com/@dr.gilbertoinfecto"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  style={{ width: "74px" }}
                  className="tiktok reverse"
                  src={tiktok}
                  alt={"tiktokIcon"}
                />
              </a>
            </div>
          )}
        </div>
      </div>
      {mobile && (
        <>
          <div onClick={handleOpener} className={`headerOpener`}>
            <img
              src={!show ? bars : close}
              className="arrow"
              alt="double arrow"
            />
          </div>

          {show && <div onClick={handleOpener} className="headerBackground" />}
        </>
      )}
    </>
  );
};

export default Headerbar;
